module.exports = __webpack_public_path__ + "static/media/view5.a72c7b18.jpg";